import script from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectForm.vue?vue&type=style&index=0&id=7e0cdd63&lang=scss"

const __exports__ = script;

export default __exports__